"use client";

import Image, { StaticImageData } from "next/image";
import React from "react";
import styles from "./HeroSection.module.css";

interface HeroSectionProps {
  title: string;
  subtitle: string;
  buttonText: string;
  image: string | StaticImageData;
}

const HeroSection: React.FC<HeroSectionProps> = ({
  title,
  subtitle,
  buttonText,
  image,
}) => {
  return (
    <div className="navbarBg py-5">
      <section
        id="header-section"
        className={`container-lg text-white ${styles.heroSection}`}
      >
        <div className="row align-items-center gy-4">
          {/* LEFT CONTENT */}
          <div className="col-12 col-lg-7 col-md-12 text-center text-md-start">
            <div className={styles.contentWrap}>
              <h2 className={`fs-1 fw-bold ${styles.title}`}>
                {title}
              </h2>

              <p className={`fs-5 ${styles.subtitle}`}>
                {subtitle}
              </p>

              <div className={styles.buttonWrap}>
                <a
                  href="#ContactForm"
                  className={`btn btn-lg ${styles.ctaButton}`}
                >
                  {buttonText}
                </a>
              </div>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="col-12 col-lg-5 col-md-12 text-center">
            <Image
              src={image}
              alt="Hero Image"
              width={600}
              height={500}
              priority
              className={`img-fluid ${styles.heroImage}`}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default HeroSection;
